import React, { useContext } from 'react';
import {Jelly} from '../Jelly';
import {styled} from '@volkswagen-onehub/components-core';
import { ResultsView, ResultsViewContext } from '../../../utils/results-view-context';
import { VehicleContext } from '../../../utils/vehicle-context';

interface CardJellyContainerInterface {
  view ?: ResultsView;
  sold ?: boolean;
}

interface CardJellyInterface {
  sold ?: boolean;
}

const CardJellyContainer = styled.div<CardJellyContainerInterface>`
  background-color: #eee;
  grid-area: jelly;
  display: flex;
  align-items: center;
  height: 100%;

  ${props => props.sold && `
    opacity: 0.5;
  `}
`;

const CardJelly : React.FC<CardJellyInterface> = () => {
  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext);
  const sold = vehicle?.deleted;

  return (
    <CardJellyContainer view={view} sold={sold}>
      <Jelly />
    </CardJellyContainer>
  );
};

export default CardJelly;
